/* eslint-disable radix */
import React, { useState } from 'react';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import { PaginationList, PaginationButton } from './Pagination.styles';
import { RiArrowLeftDoubleFill } from 'react-icons/ri';
import { RiArrowRightDoubleFill } from 'react-icons/ri';
import UsePagination from '../UsePagination';
import CenterModal from '../Modal/CenterModal';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from '../../../Context/authContext';

function Pagination(props) {
  const {
    onPageChange,
    totalCount,
    siblingCount = 1,
    currentPage,
    pageSize,
    customCss,
    invoiceTablePagination,
    invoiPaginationPrevClick,
    invoiPaginationPrevDisabled,
    invoiPaginationNextClick,
    invoiPaginationNextDisabled,
  } = props;

  const paginationRange = UsePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize,
  });

  const { user } = useContextHook(AuthContext, v => ({
    user: v.user,
  }));
  const [noCreditModal, setNoCreditModal] = useState(false);

  if (!invoiceTablePagination && (!paginationRange || paginationRange.length < 2)) {
    return null;
  }

  const lastPage = paginationRange ? paginationRange[paginationRange.length - 1] : 1;

  const onNext = () => {
    if (currentPage < lastPage) {
      onPageChange(currentPage + 1);
    }
  };

  const onPrevious = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const onFirst = () => onPageChange(1);
  const onLast = () => onPageChange(lastPage);

  return (
    <>
      <CenterModal open={noCreditModal} setOpen={setNoCreditModal} width="600" noHead>
        <div className="leads-modal">
          <p>You don’t have enough credits to view this data. Please upgrade your plan to continue.</p>
        </div>
      </CenterModal>
      <PaginationList css={customCss} dir="ltr">
        {!invoiceTablePagination && (
          <>
            {/* First */}
            <PaginationButton type="button" onClick={onFirst} disabled={currentPage <= 1}>
              <RiArrowLeftDoubleFill className="icon duble" />
            </PaginationButton>

            {/* Previous */}
            <PaginationButton type="button" onClick={onPrevious} disabled={currentPage <= 1}>
              <IoIosArrowBack className="icon" />
            </PaginationButton>

            {/* Page Numbers */}
            {paginationRange.map((pageNumber, index) => {
              if (pageNumber === '...') {
                return (
                  <span key={index} className="dots">
                    ...
                  </span>
                );
              }
              return (
                <PaginationButton
                  key={index}
                  type="button"
                  onClick={() => onPageChange(pageNumber)}
                  className={pageNumber === currentPage ? 'active' : ''}>
                  {pageNumber}
                </PaginationButton>
              );
            })}

            {/* Next */}
            <PaginationButton type="button" onClick={onNext} disabled={currentPage >= lastPage}>
              <IoIosArrowForward className="icon" />
            </PaginationButton>

            {/* Last */}
            <PaginationButton type="button" onClick={onLast} disabled={currentPage >= lastPage}>
              <RiArrowRightDoubleFill className="icon duble" />
            </PaginationButton>
          </>
        )}
        {invoiceTablePagination && (
          <div className="pagination-buttons">
            <PaginationButton onClick={invoiPaginationPrevClick} disabled={invoiPaginationPrevDisabled}>
              <IoIosArrowBack className="icon" />
            </PaginationButton>
            <PaginationButton onClick={invoiPaginationNextClick} disabled={invoiPaginationNextDisabled}>
              <IoIosArrowForward className="icon" />
            </PaginationButton>
          </div>
        )}
      </PaginationList>
    </>
  );
}

export default Pagination;
